import { Routes } from '@angular/router';

export const profissionalRoutes: Routes = [
  {
    path: 'profissional',
    canActivate: [() => import('../../core/guards/profissional.guard').then(m => m.profissionalGuard)],
    loadComponent: () => import('./layout/layout.component').then(m => m.ProfissionalLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'servicos',
        loadComponent: () => import('./servicos/servicos.component').then(m => m.ServicosComponent)
      },
      {
        path: 'agenda',
        loadComponent: () => import('./agenda/agenda.component').then(m => m.AgendaComponent)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./perfil/perfil.component').then(m => m.PerfilComponent)
      },
      {
        path: 'avaliacoes',
        loadComponent: () => import('./avaliacoes/avaliacoes.component').then(m => m.AvaliacoesComponent)
      },
      {
        path: 'notificacoes',
        loadComponent: () => import('./notificacoes/notificacoes.component').then(m => m.NotificacoesComponent)
      },
      {
        path: 'relatorios',
        loadComponent: () => import('./relatorios/relatorios.component').then(m => m.RelatoriosComponent)
      },
      {
        path: 'configuracoes',
        loadComponent: () => import('./configuracoes/configuracoes.component').then(m => m.ConfiguracoesComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }
];
